export default __webpack_public_path__ + "static/media/fabric5.986ced35.png";